<div class="modal where-find-imei">
    <div class="model-container">
        <div class="modal-header">
                <h3 class="modal-heading" translate>imei-modal.where-to-find-ime</h3>
                <img class="modal-close" (click)="closeDialog()" src="/assets/icon/primary-close.svg" alt="close-icon"
                    width="28" height="28">
        </div>
        <div class="modal-body">
            <p translate>imei-modal.from-the-keybad <b translate>imei-modal.*#06#</b> <span translate>imei-modal.this-imei-will</span></p>
            <p class="or" translate>imei-modal.or</p>
            <p translate>imei-modal.check-settings-menu</p>
            <div class="aligned-content">
                <p class="sub-btm"><b translate>imei-modal.android</b></p>
                <p class="btm" translate>imei-modal.got-to <b translate>imei-modal.settings-about</b></p>
                <p class="sub-btm"><b translate>imei-modal.iphone</b></p>
                <p class="btm" translate>imei-modal.got-to <b translate>imei-modal.settings-general</b></p>
                <p class="sub-btm"><b translate>imei-modal.windows-phone</b></p>
                <p translate>imei-modal.got-to <b translate>imei-modal.settings-more-info</b></p>
            </div>

            <div class="modal-actions">
                <button class="button primary" aria-label="Got it!" (click)="closeDialog(true)" translate>imei-modal.got-it</button>
            </div>
        </div>
    </div>
</div>